module.exports = __webpack_public_path__ + "img/default-head.b2916070.png";